module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "swiper"
  }, [_c('div', {
    staticClass: "swiper-container personal"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.appShow), function(item) {
    return _c('div', {
      key: item,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticClass: "app_show",
      attrs: {
        "src": item
      }
    })])
  }), 0)]), _vm._v(" "), (_vm.appShow.length > 1) ? _c('div', {
    staticClass: "swiper-button-prev"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]) : _vm._e(), _vm._v(" "), (_vm.appShow.length > 1) ? _c('div', {
    staticClass: "swiper-button-next"
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-71657d3e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/pro_detail.vue
// module id = S2CU
// module chunks = 0